import React from "react";
import Index from "pages/index";
import Pricing from "pages/pricing";
import Whitepaper from "pages/whitepaper";
import ComingSoon from "pages/comingSoon";
import Page404 from "pages/page404";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import theme from "theme";

const GlobalStyles = createGlobalStyle`
    *,
    *::before,
    *::after {
        box-sizing: border-box;
    }
    body {
        margin: 0;
        padding: 0;
        font-family: ${theme.fontFamily.sans};
        color: ${theme.color.dark};
        background: ${theme.color.surface};
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    a:focus-visible,
    button:focus-visible,
    summary:focus-visible {
        outline: 2px solid ${theme.color.primary};
        outline-offset: 2px;
    }
`;

export default () => (
    <Router>
        <GlobalStyles />
        <Switch>
        			<Route exact path='/' component={Index}/>
			<Route exact path='/index' component={Index}/>
			<Route exact path='/pricing' component={Pricing}/>
			<Route exact path='/whitepaper' component={Whitepaper}/>
			<Route exact path='/coming-soon' component={ComingSoon}/>
			<Route component={Page404}/>
        </Switch>
    </Router>
);
